var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHumanLog(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon / human (no photo)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Live-DAC",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Private-car-Tailgating-Copy-3",
    transform: "translate(-692.000000, -717.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Past-entries",
    transform: "translate(80.000000, 603.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "driver",
    transform: "translate(509.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-/-human-(no-photo)",
    transform: "translate(103.000000, 95.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#979797",
    strokeWidth: 0.8,
    fill: "#D8D8D8",
    x: 0.4,
    y: 0.4,
    width: 31.2,
    height: 31.2,
    rx: 1.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/person/person_black",
    transform: "translate(5.000000, 6.000000)",
    fill: "#000000",
    fillOpacity: 0.87,
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1746032,13.9849824 C12.5574951,13.9849824 14.0741926,14.1857218 15.724741,14.5872065 C17.5983365,15.0556054 19.115034,15.6801279 20.2748788,16.4607927 C21.6577708,17.3752858 22.3492063,18.401287 22.3492063,19.5388271 L22.3492063,22.3492063 L0,22.3492063 L0,19.5388271 C0,18.401287 0.691435597,17.3752858 2.07432754,16.4607927 C3.23417239,15.6801279 4.75086983,15.0556054 6.62446536,14.5872065 C8.2750138,14.1857218 9.79171124,13.9849824 11.1746032,13.9849824 Z M11.1746032,11.1746032 C10.1708913,11.1746032 9.24525976,10.923679 8.39768083,10.421823 C7.5501019,9.91996708 6.87539458,9.24525976 6.37353864,8.39768083 C5.87168269,7.5501019 5.62075848,6.62447037 5.62075848,5.62075848 C5.62075848,4.61704659 5.87168269,3.68026288 6.37353864,2.81037924 C6.87539458,1.9404956 7.5501019,1.2546361 8.39768083,0.752780154 C9.24525976,0.250924209 10.1708913,1.0658141e-13 11.1746032,1.0658141e-13 C12.1783151,1.0658141e-13 13.1039466,0.250924209 13.9515255,0.752780154 C14.7991045,1.2546361 15.4738118,1.9404956 15.9756677,2.81037924 C16.4775237,3.68026288 16.7284479,4.61704659 16.7284479,5.62075848 C16.7284479,6.62447037 16.4775237,7.5501019 15.9756677,8.39768083 C15.4738118,9.24525976 14.7991045,9.91996708 13.9515255,10.421823 C13.1039466,10.923679 12.1783151,11.1746032 11.1746032,11.1746032 Z",
    id: "icon/person/black"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumanLog);
export default __webpack_public_path__ + "static/media/human_log.e16ed6146f1833937545555a8ae615a1.svg";
export { ForwardRef as ReactComponent };